import React from 'react';
import {Button, Drawer, Select, Upload} from "antd";
import {UploadOutlined} from "@ant-design/icons";

const TYPE_TALENT_CONTRACT = 2;
const TYPE_SIGNED_TALENT_CONTRACT = 8;

const UploadTalentContract = ({title = "Manage Talent Contract",onClose, isOpen, formModel, setFormModel, onUpload, isDisabled, ...props}) => {


    const uploadProps = {
        onRemove: async (file) => {
            setFormModel({...formModel, signed_contract_at: null, document_path: undefined});
        },
        beforeUpload: (file) => {
            setFormModel({...formModel, document_path: file});
            return false;
        },
        fileList: formModel.document_path ? [formModel.document_path] : [],
        showUploadList: {
            showDownloadIcon: true,
            showRemoveIcon: true,
            showPreviewIcon: true
        }
    };

    return (
        <Drawer
            title={(
                <div className="flex flex-row items-center gap-2">
                    <p className="font-semibold underline">
                        {title}
                    </p>
                </div>
            )}
            width={540}
            onClose={onClose}
            open={isOpen}
            bodyStyle={{paddingBottom: 80}}
        >

            <div className="position-contract-drawer-form">

                <div className="flex flex-col gap-5">

                    <div className="gap-2 flex flex-row items-center">
                        <p className="font-semibold w-44">
                            Contract Type
                        </p>
                        <Select
                            defaultValue={TYPE_TALENT_CONTRACT}
                            value={formModel.document_type}
                            onChange={(document_type) => setFormModel({...formModel, document_type})}
                            options={[
                                {value: TYPE_TALENT_CONTRACT, label: 'Talent Contract (Unsigned)'},
                                {value: TYPE_SIGNED_TALENT_CONTRACT, label: 'Signed Talent Contract'},
                            ]}
                        />
                    </div>
                    <div className="gap-2 flex flex-row items-center">
                        <p className="font-semibold w-44 whitespace-nowrap">
                            Upload Document
                        </p>
                        <div className="h-[36px] overflow-hidden">
                            <Upload {...uploadProps} multiple={false} maxCount={1}>
                                {!formModel.document_path && (
                                    <Button icon={<UploadOutlined/>}>Select File</Button>
                                )}
                            </Upload>
                        </div>
                    </div>

                    <div className="flex flex-row items-center gap-3 justify-end">

                        <button className="mt-5 btn btn-outline-dark" onClick={onClose}
                                disabled={isDisabled}>
                            Cancel
                        </button>

                        <button onClick={async () => {
                            let model = formModel;
                            if (model.document_type === TYPE_SIGNED_TALENT_CONTRACT) {
                                model = TB.set(formModel, 'signed_contract_at', new Date())
                            }
                            await onUpload(model);
                            return onClose()
                        }} disabled={!formModel.document_path || isDisabled}
                                className="mt-5 btn-primary btn">
                            Upload
                        </button>

                    </div>
                </div>
            </div>
        </Drawer>
    )
};

export default UploadTalentContract;